<div class="ptl-color-swatch">
  <input
    readonly
    class="ptl-color-swatch__input"
    [attr.aria-label]="ariaLabel"
    [colorPicker]="value"
    [cpEyeDropper]="eyeDropper"
    [cpOutputFormat]="'hex'"
    [cpPosition]="position"
    [style.background]="value"
    (colorPickerChange)="onColorChange($event)"
  />
  <span class="ptl-color-swatch__value">{{ value }}</span>
</div>
